import { useMemo, useState } from "react";
import { dramas, genres } from "@/mocks/content";

export default function CatalogSection() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () => (active === "全部" ? dramas : dramas.filter((d) => d.genre === active)),
    [active]
  );

  return (
    <section id="catalog" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl" data-reveal>
            <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
              题材选片：按类型筛选想看的方向
            </h2>
            <p className="mt-3 text-foreground-600 leading-8">
              下面按都市温情、家庭伦理、逆袭成长、悬疑情感与治愈生活五类整理。
              点击标签即可在本页筛选，列表会实时更新，不会跳转到其他页面。
            </p>
          </div>
          <p className="text-sm text-foreground-500 shrink-0">
            当前显示 <span className="text-primary-600 font-medium">{list.length}</span> / {dramas.length} 条
          </p>
        </div>

        <div className="mt-6 flex flex-wrap gap-2" role="tablist" aria-label="题材筛选">
          {genres.map((g) => {
            const isActive = g === active;
            return (
              <button
                key={g}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActive(g)}
                className={
                  isActive
                    ? "px-4 py-1.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                    : "px-4 py-1.5 rounded-full bg-background-50 border border-background-200 text-foreground-700 text-sm hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                }
              >
                {g}
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {list.map((d) => (
            <article
              key={d.id}
              data-reveal
              className="group flex flex-col rounded-xl overflow-hidden bg-background-50 border border-background-200"
            >
              <div className="relative w-full h-56 md:h-64 bg-background-200 overflow-hidden">
                <img
                  src={d.poster}
                  alt={`${d.title} 题材海报插画`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-2.5 left-2.5 px-2.5 py-1 rounded-md bg-background-50/95 text-[11px] text-foreground-700">
                  {d.genre}
                </span>
                <span className="absolute bottom-2.5 right-2.5 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-[11px] font-medium">
                  {d.score.toFixed(1)}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-4">
                <h3 className="font-heading font-semibold text-base text-foreground-950">
                  {d.title}
                </h3>
                <p className="mt-1 text-[11px] text-secondary-700">
                  {d.tag} · {d.episodes} 集 · {d.status}
                </p>
                <p className="mt-2.5 text-xs text-foreground-600 leading-6 flex-1">{d.summary}</p>
                <div className="mt-3 pt-3 border-t border-background-200 flex items-center justify-between text-[11px] text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-flashlight-line text-accent-600" aria-hidden="true"></i>
                    {d.heat}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-refresh-line" aria-hidden="true"></i>
                    {d.update}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 text-xs text-foreground-500 leading-6" data-reveal>
          注：以上条目为本站按年轻母亲题材常见类型整理的编辑示例，用于说明题材差异与叙事特点，
          具体内容与版本请以你观看的平台为准。
        </p>
      </div>
    </section>
  );
}